import FetchPromise from '~/agent/fetch-promise';
import { useDefaultMutation } from '~/lib/react-query';

export interface CreateSourceDocumentParams {
  fileName: string;
  fileType: string;
  fileChecksum: string;
  fileSize: number;
}

interface SourceDocument {
  id: string;
  uploadMetadata: {
    signedId: string;
    url: string;
    headers: Record<string, string>;
  };
  uploader: {
    id: number;
    name: string;
    avatarUrl: string;
  };
  createdAt: number;
  updatedAt: number;
}

export function createSourceDocument(params: CreateSourceDocumentParams): Promise<SourceDocument> {
  return FetchPromise.post(`source_documents`, {
    filename: params.fileName,
    byte_size: params.fileSize,
    checksum: params.fileChecksum,
    content_type: params.fileType,
  });
}

export function useCreateSourceDocumentMutation() {
  return useDefaultMutation(createSourceDocument);
}
